import { useQuery } from '@tanstack/react-query';
import { withdrawalAnalysisApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 退会者分析ダッシュボードデータを取得するフック。サマリー・解約理由・満足点・月次トレンド・フリーテキスト。
 * @graph-connects withdrawalAnalysisApi [calls] Withdrawal Analysis API client
 * @graph-connects queryKeys [calls] Query key factory
 */
export function useWithdrawalAnalysis() {
  return useQuery({
    queryKey: queryKeys.withdrawalAnalysis.data,
    queryFn: () => withdrawalAnalysisApi.getData(),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
